export default {
    "general": {
        "Save"                        : "Guardar",
        "Send"                        : "Enviar",
        "Cancel"                      : "Cancelar",
        "istobal-logo"                : "ISTOBAL - Vehicle Wash & Care",
        "logo_istobal"                : "ISTOBAL - Vehicle Wash & Care",
        "Models"                      : "Modelos",
        "Plain"                       : "Plano",
        "Rocket"                      : "Rocket",
        "Zenit"                       : "Zenit",
        "Cubik"                       : "Cubik",
        "PremiumLed"                  : "Premium con Led",
        "PremiumMethacrylate"         : "Premium Metacrilato",
        "Premium"                     : "Premium",
        "Structure"                   : "Estructura",
        "estructura"                  : "Estructura",
        "Fairing"                     : "Carenado",
        "carenado"                    : "Carenado",
        "Front/rearFairing"           : "Cabecera superior",
        "cabut"                       : "Cabeceras superiores",
        "Front/rearFairings"          : "Cabeceras superiores",
        "cabuts"                      : "Cabeceras superiores",
        "Door"                        : "Puerta",
        "puerta"                      : "Puerta",
        "Doors"                       : "Puertas",
        "PlainDoor"                   : "Plana",
        "Led"                         : "Led",
        "WheelWash"                   : "Lavarruedas",
        "lavarruedas"                 : "Lavarruedas",
        "Light"                       : "Luminoso",
        "luminoso"                    : "Luminoso",
        "luminososuperior"            : "Luminoso superior",
        "Lights"                      : "Luminosos",
        "TrafficLight"                : "Semáforo",
        "TrafficLightPositioning"     : "Semáforo de posicionado",
        "Sferic"                      : "Sferic",
        "Boomerang"                   : "Boomerang",
        "Linear"                      : "Linear",
        "Pictogram"                   : "Pictograma",
        "pictograma"                  : "Pictograma",
        "pictogramasuperior"          : "Pictograma superior",
        "Pictograms"                  : "Pictogramas",
        "PitLane"                     : "Pit Lane",
        "Pictogram2020"               : "Pictograma 2020",
        "Volaverunt"                  : "Volaverunt",
        "VolaveruntBlanco"            : "Volaverunt blanco",
        "VolaveruntNegro"             : "Volaverunt negro",
        "Color"                       : "Color",
        "Silver"                      : "Silver",
        "Hexa"                        : "Hexa",
        "Brushes"                     : "Cepillos",
        "basicSelector"               : "Básico",
        "basicSelectorInvert"         : "Avanzado",
        "advancedSelector"            : "Avanzado",
        "Flat"                        : "Liso",
        "Liso"                        : "Liso",
        "3stripes"                    : "Bandas",
        "Bandas"                      : "Bandas",
        "Streaked"                    : "Personalizado",
        "Rayado"                      : "Personalizado",
        "CONFIGURATOR"                : "CONFIGURADOR",
        "SelectAnOption"              : "Seleccione uno de los puentes de lavado para configurarlo",
        "select"                      : "seleccionar",
        "ClickSelectColor"            : "Haga click para seleccionar el color",
        "ClickSelectColorPatron"      : "Modifique el color de cada teja",
        "ColorSelector"               : "Selector de colores",
        "SelectColor"                 : "Seleccionar color",
        "Yes"                         : "Sí",
        "No"                          : "No",
        "SaveConfig"                  : "Guardar",
        "Share"                       : "Compartir",
        "ContactUs"                   : "Contactar",
        "ShareContact"                : "Compartir o guardar",
        "FrontImage"                  : "Imagen frontal",
        "BackImage"                   : "Imagen trasera",
        "FrontRender"                 : "Render frontal",
        "BackRender"                  : "Render trasera",
        "PrivacyText"                 : "Las imágenes, videos e informaciones que aparecen en este espacio son meramente ilustrativos y no vinculantes, pueden ser opcionales o no estar disponibles según el modelo, y no constituyen una oferta. Puede contactar con el departamento comercial de ISTOBAL para cualquier información adicional o solicitud de oferta de nuestros productos. La información de este configurador no podrá ser considerada una orden de compra, pedido o una oferta de venta, ni como un medio para suscribir ningún tipo de compraventa u otro tipo de contrato o acuerdo con ISTOBAL, S.A. o con las entidades pertenecientes a su grupo empresarial. En caso de que los Usuarios deseen adquirir algún producto ISTOBAL con las características y equipamientos indicados en la configuración, pueden contactar con la Red Comercial de ISTOBAL S.A. quién informará a los Usuarios del precio de venta definitivo del producto. La información facilitada a través de este configurador es orientativa y no exhaustiva. Asimismo, esta información puede no estar actualizada en cada momento. ISTOBAL S.A.. no garantiza que la concreta configuración escogida por el Usuario esté total o parcialmente disponible, ni que sus características, descripciones u otros datos puedan variar entre la visita a esta página y la formalización del contrato de compraventa del producto con el asesor comercial correspondiente.",
        "RightsReserved"              : "Todos los derechos reservados",
        "E-mail"                      : "E-mail",
        "E-mailPlaceholder"           : "Escribe tu E-mail",
        "DownloadPDF"                 : "Descargar PDF",
        "CopyLink"                    : "Copiar enlace",
        "Help"                        : "Ayuda",
        "NeedHelp"                    : "¿Necesitas ayuda?",
        "CallTo"                      : "Llamar +34 96 111 10 20",
        "CallToPhone"                 : "+34961111020",
        "ContactUsTitle"              : "Contáctanos y uno de nuestros profesionales te asesorará",
        "ContactUsIframeURL_es_en"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhl",
        "ContactUsIframeURL_es_es"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhp",
        "ContactUsIframeURL_int_en"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhl",
        "ContactUsIframeURL_int_es"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhp",
        "ContactUsIframeURL_us_es"    : "https://go.istobal.com/l/954553/2022-05-10/411s2",
        "ContactUsIframeURL_us_en_us" : "https://go.istobal.com/l/954553/2022-05-10/411s2",
        "ContactUsIframeURL_br_en"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhl",
        "ContactUsIframeURL_br_pt"    : "https://go.istobal.com/l/954553/2022-05-31/4nfhp",
        "AskInformation"              : "Solicitar más información",
        "Exit"                        : "Salir",
        "Close"                       : "Cerrar",
        "ChooseAnOptionCustomRollover": "Seleccione qué prefiere hacer con el puente de lavado que ha configurado",
        "clipboardLink"               : "¡Link copiado al portapapeles!",
        "emailSending"                : "Enviando a ... ",
        "emailSent"                   : "¡Enviado!",
        "emailError"                  : "¡Error! Vuelve a intentarlo en unos minutos o descarga el PDF",
        "emailFormat"                 : "Introduce un email válido",
        "ConfiguracionesiQuote"       : "Configuraciones estándar:",
        "Aceptar"                     : "Aceptar",
        "Notice"                      : "Aviso",
        "NoticeText"                  : 'Recuerda que iQuote permite configurar los puentes con un color o dos colores con cuatro tipos de combinaciones. El resto de configuraciones no incluidas en iQuote no podrán ser producidas.<br /><br />Pulsa el icono de info <span data-v-16b6fa28="" class="icon is-small"><svg class="svg-inline--fa fa-info-circle fa-w-16" aria-hidden="true" data-prefix="fas" data-icon="info-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"></path></svg><!-- <i class="fas fa-info-circle"></i> --></span> para más información sobre las combinaciones disponibles en cada máquina.',
        "ConfStandardIQuote"          : 'Configuraciones estándard',
        "UnColor"                     : '1A',
        "Central"                     : 'Central',
        "Posterior"                   : 'Posterior'

    }

}
